
import { defineComponent } from "vue";
import DoctorsList from "@/components/Departments/common/DoctorsListTemplate2.vue";
import { DepartmentPropDataInterface } from "@/ts/interfaces";

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: "Nephrology Doctors",
      queryName: "Nephrology",
      teamName: "Nephrology team",
    };
  },
  components: { DoctorsList },
});
